export const PAGE_BACKGROUND = '#F7F7F7';
export const BACKDROP_OVERLAY = '#00000099';
